// Typescript version of sb1/db/accounts.py:Permissions
enum Permissions {
  // CS features
  BetaMessages = "beta-messages",
  HiddenIntegrations = "hidden-integrations",
  EmailIngestV3 = "email-ingest-v3",

  // Test features
  TestScreens = "test-screens",

  // Needs to be sorted out; see #10296 and #15040.
  Backfill = "backfills", // The new backfills UI, both launch and view.
  ManagePipelines = "manage-pipelines", //Applies to the old backfill button and the new launch backfill workflow.

  // View; everyone with a login gets this permission.
  View = "view",

  // Script, key and integrations management.
  DevelopScripts = "develop-scripts",
  ManageKeys = "manage-keys",
  PublishScripts = "publish-scripts",
  ManageIntegrations = "manage-integrations",

  // Account management.
  ListAccounts = "list-accounts",
  ListAccountsV2 = "list-accounts-v2",
  ManageAccounts = "manage-accounts",
  ManageAccountSettings = "manage-account-settings",
  // ListAccountsV2 = "list-accounts-v2"

  // User management.
  ManageGlobalUsers = "manage-global-users",
  ManageUsers = "manage-users",

  // # Beta permission for CS to view diffs; will eventually be part of develop-scripts.
  ViewDiffsBeta = "view-diffs-beta",

  // # Beta permission for CS to operate wizards
  OperateWizardsBeta = "operate-wizards-beta",
}
export default Permissions;
